// extracted by mini-css-extract-plugin
export default {"gradientFill":"DiyAwh","title":"EuWcY1","wrappingTitle":"kcUEBx"};